import React from 'react';
import { TooltipContent, TooltipStyled } from 'src/components/Tooltip/Tooltip.style';

type TooltipPropsType = {
    children: React.ReactNode;
    content: React.ReactNode;
    direction?: 'right' | 'left';
};
export const Tooltip = ({ children, content, direction }: TooltipPropsType): JSX.Element => {
    return (
        <TooltipStyled>
            {children}
            <TooltipContent
                className='tooltip-content'
                direction={direction}
            >
                {content}
            </TooltipContent>
        </TooltipStyled>
    );
};
